module.exports = __webpack_public_path__ + "img/Ellipse-295.1da50357.svg";